import { Link } from 'react-router-dom';

// A link to a section of the landing page.
//
// A bare '#features' anchor resolves against the CURRENT path, so on /contact
// or /privacy-policy it points at a section that page does not have and does
// nothing. This link always addresses the landing page, and scrolls in place
// when the section is already on screen.
function SectionLink({ id, children, onClick, ...rest }) {
  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }

    const target = document.getElementById(id);
    if (!target) {
      // Not this page: let the router navigate to the landing page, which
      // scrolls to the section named by the hash when it mounts.
      return;
    }

    event.preventDefault();
    scrollToSection(target);
  };

  return (
    <Link to={`/#${id}`} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}

// jsdom does not implement scrollIntoView, and neither does every browser
// engine for the smooth behaviour, so both are optional here.
export function scrollToSection(target) {
  if (typeof target.scrollIntoView === 'function') {
    target.scrollIntoView({ behavior: 'smooth' });
  }
}

export default SectionLink;
